import { Box } from "@mui/material";
import { SmartAutoComplete, SmartCheckbox } from "@nodeon/react-components";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDropdownOptions } from "../hooks/useDropdownOptions";
import { SearchFormData } from "../tabs/SecurityDeviceSearchTab";
import { SharedFormProps } from "../WaterTrafficSignContainers/WaterTrafficSignStateForm";

export type ComponentsFormTypes = {
  componentType: string | null;
  component: string | null;
  noComponent: boolean;
};

export const componentFormDefaultValues: ComponentsFormTypes = {
  component: null,
  componentType: null,
  noComponent: false,
};

export const ComponentsForm = ({ isDisabled }: SharedFormProps) => {
  const { t } = useTranslation("fairwayReport");
  const { control } = useFormContext<SearchFormData>();
  const { searchResult, isLoading } = useDropdownOptions();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      {/* <Typography>{t("fairwayReport:deviceIdOrName")}</Typography> */}
      <SmartAutoComplete<SearchFormData, string, false>
        name="componentType"
        label={t("fairwayReport:componentClass")}
        options={searchResult?.componentTypes ?? []}
        controllerProps={{ control }}
        loading={isLoading}
        disabled={isDisabled}
      />
      <SmartAutoComplete<SearchFormData, string, false>
        name="component"
        label={t("fairwayReport:component")}
        options={searchResult?.components ?? []}
        controllerProps={{ control }}
        loading={isLoading}
        disabled={isDisabled}
      />
      <SmartCheckbox<SearchFormData>
        label={t("noComponent")}
        name="noComponent"
        controllerProps={{ control }}
        disabled={isDisabled}
      />
      {/* <FormControl>
        <FormLabel>{t("fairwayReport:variant")}</FormLabel>
        <Controller<SearchFormData>
          name="subType"
          control={control}
          render={({ field }) => (
            <RadioGroup
              sx={{ display: "flex", flexDirection: "row" }}
              {...field}
            >
              <FormControlLabel
                value="Kaikki"
                control={<Radio />}
                label="Kaikki"
              />
              <FormControlLabel
                value="Kiinteä"
                control={<Radio />}
                label="Kiinteä"
              />
              <FormControlLabel
                value="Kelluva"
                control={<Radio />}
                label="Kelluva"
              />
            </RadioGroup>
          )}
        />
      </FormControl> */}
    </Box>
  );
};
